const Users = () => import('@/views/system/Users')
const Role = () => import('@/views/system/Role')
const Product = () => import('@/views/system/Product')
const Term = () => import('@/views/system/TermCollect')
const PersonalCenter = () => import('@/views/system/PersonalCenter')
const FinancialSecurity = () => import('@/views/system/FinancialSecurity')
const PassConfig = () => import('@/views/system/PassConfig')

export const system = [
  {
    path: '/system/role',
    name: '角色管理',
    component: Role,
    meta: {
      requireAuth: true,
      title: '角色管理'
    }
  },
  {
    path: '/system/user',
    name: '账号管理',
    component: Users,
    meta: {
      requireAuth: true,
      title: '账号管理'
    }
  },
  {
    path: '/system/rolePrivilege',
    name: '角色权限',
    component: Users,
    meta: {
      requireAuth: true,
      title: '角色权限'
    }
  },
  {
    path: '/system/configure',
    name: '系统配置',
    component: Users,
    meta: {
      requireAuth: true,
      title: '系统配置'
    }
  },
  {
    path: '/system/dictionnary',
    name: '字典管理',
    component: Users,
    meta: {
      requireAuth: true,
      title: '字典管理'
    }
  },
  {
    path: '/system/button',
    name: '按钮管理',
    component: Users,
    meta: {
      requireAuth: true,
      title: '按钮管理'
    }
  },
  {
    path: '/system/menu',
    name: '菜单管理',
    component: Users,
    meta: {
      requireAuth: true,
      title: '菜单管理'
    }
  },
  {
    path: '/log/operation',
    name: '操作日志',
    component: Users,
    meta: {
      requireAuth: true,
      title: '菜单管理'
    }
  },
  {
    path: '/log/login',
    name: '登录日志',
    component: Users,
    meta: {
      requireAuth: true,
      title: '登录日志'
    }
  },
  {
    path: '/user/info',
    name: '用户详情',
    component: Users,
    meta: {
      requireAuth: true,
      title: '用户详情'
    }
  },
  {
    path: '/system/refresh',
    name: '缓存刷新',
    component: Users,
    meta: {
      requireAuth: true,
      title: '缓存刷新'
    }
  },
  {
    path: '/system/product',
    name: '产品管理',
    component: Product,
    meta: {
      requireAuth: true,
      title: '产品管理'
    }
  },
  {
    path: '/system/termCollect',
    name: '采集管理',
    component: Term,
    meta: {
      requireAuth: true,
      title: '采集管理'
    }
  },
  {
    path: '/system/personal/center',
    name: '个人中心',
    component: PersonalCenter,
    meta: {
      requireAuth: true,
      title: '个人中心'
    }
  },
  {
    path: '/system/financial/security',
    name: '财务安全',
    component: FinancialSecurity,
    meta: {
      requireAuth: true,
      title: '财务安全'
    }
  },
  {
    path: '/system/pass/config',
    name: '通道配置',
    component: PassConfig,
    meta: {
      requireAuth: true,
      title: '通道配置'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/system.route.js